import { put, takeLatest } from "redux-saga/effects";
import { actionTypes } from "Redux/services/actionTypes";
import apiCall from "Redux/services/apiCall";
import { PAYBACK_LIST } from "Redux/services/apiTypes";

export function* getPaybackListWatcher() {
  yield takeLatest(actionTypes.GET_PAYBACK_LIST_METHOD, getPaybackListWorker);
}

function* getPaybackListWorker(action) {
  try {
    let url = {
      type: PAYBACK_LIST + action.payload.query,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.GET_PAYBACK_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.GET_PAYBACK_LIST_FAIL, payload: error });
  }
}
